export default "__VITE_ASSET__b993448e__"